import React, { useMemo } from 'react'
import GeneralPanel from './GeneralPanel'
import PilotPanel from './PilotPanel'
import InstructorPanel from './InstructorPanel'
import TabbedPage from '../_library/TabbedPage'
import { compact } from 'lodash'
import useAuth from '../../hooks/useAuth'
import { useSelector } from 'react-redux'
import AirportOverviewPanel from '../airports/AirportOverviewPanel'
import ApisOverviewPanel from './ApisOverviewPanel'


const SettingsPage = () => {
  
  const profile = useAuth().getProfile()
  const adminMode = useSelector(state => state.data.adminMode)
  
  const tabs = useMemo(() => compact([
    {
      key: 'general',
      label: 'Général',
      route: 'general',
      content: <GeneralPanel />,
    },
    {
      key: 'pilot',
      label: 'Pilote',
      route: 'pilot',
      content: <PilotPanel />,
    },
    profile.roles.includes('instructeur') && {
      key: 'instructor',
      label: 'Instructeur',
      route: 'instructor',
      content: <InstructorPanel />,
    },
    adminMode && {
      key: 'airports',
      label: 'Airports',
      route: 'airports',
      content: <AirportOverviewPanel />,
    },
    adminMode && {
      key: 'apis',
      label: 'APIs',
      route: 'apis',
      content: <ApisOverviewPanel />,
    },
  ]), [profile.roles, adminMode])

  return <TabbedPage tabs={tabs} />
}

export default SettingsPage
